/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Full_Mock_5Inputs */

const en_cap_full_mock_5 = /** @type {(inputs: Cap_Full_Mock_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infrastructure`)
};

const lv_cap_full_mock_5 = /** @type {(inputs: Cap_Full_Mock_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infrastruktūra`)
};

/**
* | output |
* | --- |
* | "Infrastructure" |
*
* @param {Cap_Full_Mock_5Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_full_mock_5 = /** @type {((inputs?: Cap_Full_Mock_5Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Full_Mock_5Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_full_mock_5(inputs)
	return en_cap_full_mock_5(inputs)
});